import React from "react";
import {
  FormControl,
  Select,
  Box,
  Chip,
  MenuItem,
  Checkbox,
  ListItemText,
  FormHelperText,
  SelectChangeEvent,
  Typography
} from "@mui/material";
import RolesDropdownProps from "./RolesDropdown.types";
import "./RolesDropdown.scss";
import { useTranslation } from "react-i18next";

function RolesDropdown(props: RolesDropdownProps) {
  const { t } = useTranslation();

  // component state
  const [selectedRoles, setSelectedRoles] = React.useState<string[]>(
    () => props.selectedRoles || []
  );

  function handleSelectRole(event: SelectChangeEvent<string[]>) {
    const value = event.target.value;
    setSelectedRoles(typeof value === "string" ? value.split(",") : value);
  }

  return (
    <FormControl fullWidth>
      <Select
        multiple
        autoWidth
        value={selectedRoles}
        displayEmpty
        size="small"
        variant="outlined"
        onChange={handleSelectRole}
        renderValue={(selected) => {
          if (selected.length === 0) {
            return (
              <Typography variant="body2" marginTop={0.4}>
                {t("rolesDropdown.inputPlaceholder")}
              </Typography>
            );
          }

          return (
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
              {selected.map((value) => {
                const [roleId, roleName] = value.split("|");
                return <Chip key={roleId} label={roleName} />;
              })}
            </Box>
          );
        }}
        inputProps={props.inputProps}
      >
        {props.roles?.map(({ roleId, roleName }) => (
          <MenuItem
            key={roleId}
            value={`${roleId}|${roleName}`}
            classes={{
              root: "roles-dropdown__role-item"
            }}
          >
            <Checkbox
              checked={selectedRoles.indexOf(`${roleId}|${roleName}`) > -1}
            />
            <ListItemText primary={roleName} />
          </MenuItem>
        ))}
      </Select>
      {props.error ? (
        <FormHelperText className="roles-dropdown__roles-error" error>
          {props.error?.message?.toString()}
        </FormHelperText>
      ) : null}
    </FormControl>
  );
}

export default RolesDropdown;
